// extracted by mini-css-extract-plugin
module.exports = {"request-headers":"_1efux","requestHeaders":"_1efux"};